<script>
import { mapActions } from 'vuex'

import SupportCallbackDialog from './_SupportCallbackDialog.vue'
import SupportCallbackResult from './_SupportCallbackResult.vue'

import BaseButtonV2 from '@/components/lavender/v2/BaseButton.vue'

export default {
  name: 'SupportMethods',
  components: {
    BaseButtonV2,
    SupportCallbackDialog,
    SupportCallbackResult,
  },
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
    supportCallbackVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleCallbackDialog: false,
    }
  },
  computed: {
    popperClass() {
      return Object.entries({
        'support-callback-dialog-popper': true,
        'is-success': this.status === 'success',
        'is-failed': this.status === 'failed',
      })
        .filter(([_, value]) => !!value)
        .map(([key]) => key)
        .join(' ')
    },
  },
  watch: {
    visibleCallbackDialog(value) {
      if (value) {
        this.status = ''
      }

      this.toggleSidebarMaskVisible(value)
    },
  },
  methods: {
    ...mapActions('app', ['toggleSidebarMaskVisible']),
    handleSubmitCallback(data) {
      this.$emit('click:submit-callback', data)
    },
  },
}
</script>

<template>
  <div class="support-methods">
    <BaseButtonV2
      is-wide
      type="primary"
      size="small"
      @click.prevent="$emit('click:chat-with-us')"
    >
      <div class="support-methods__button-content">
        <svg-icon name="chat-with-us" width="16px" height="16px" />
        {{ $t('sidebar_support_widget_chat_with_us') }}
      </div>
    </BaseButtonV2>
    <el-popover
      v-if="supportCallbackVisible"
      v-model="visibleCallbackDialog"
      placement="right"
      trigger="click"
      :popper-class="popperClass"
      :visible-arrow="false"
    >
      <SupportCallbackResult
        v-if="status === 'success' || status === 'failed'"
        :status="status"
      />
      <SupportCallbackDialog
        v-else
        :submitting="submitting"
        @cancel="visibleCallbackDialog = false"
        @submit="handleSubmitCallback"
      />
      <BaseButtonV2
        circle
        type="secondary"
        size="small"
        class="support-callback-dialog-popper__close-button"
        @click="visibleCallbackDialog = false"
      >
        <svg-icon name="close" width="16px" height="16px" color="#585B7A" />
      </BaseButtonV2>
      <BaseButtonV2
        slot="reference"
        is-wide
        type="tertiary"
        size="small"
        :disabled="submitting"
      >
        {{ $t('sidebar_support_widget_request_callback') }}
      </BaseButtonV2>
    </el-popover>
  </div>
</template>

<style lang="scss" scoped>
.support-methods {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__button-content {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}
</style>

<style lang="scss">
@import '@/styles/lavender/_typography.scss';

.support-callback-dialog-popper {
  position: relative;
  min-width: 442px;
  min-height: 420px;
  padding: 32px 24px;
  background-color: var(--tamara-color-background-bright);
  border: 1px solid var(--tamara-color-border-low);
  border-radius: 20px;

  &.is-success,
  &.is-failed {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__close-button {
    position: absolute;
    top: 20px;

    [dir='ltr'] & {
      right: 20px;
    }

    [dir='rtl'] & {
      left: 20px;
    }
  }

  &.el-popper[x-placement^='right'] {
    margin-left: 48px;
  }

  &.el-popper[x-placement^='left'] {
    margin-right: 48px;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: var(--tamara-color-brand-700);
  }

  .el-radio__label {
    @extend .tamara-english-regular-2;

    color: var(--tamara-color-content-mid) !important;
  }

  .el-radio__inner {
    width: 24px;
    height: 24px;
    border: 2.5px solid var(--tamara-color-background-neutral-high);

    &::after {
      width: 10px;
      height: 10px;
    }
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: var(--tamara-color-brand-700);
    border-color: var(--tamara-color-brand-700);
  }
}
</style>
